import React from 'react';
import AdminCRUD from './AdminCRUD';

const AdminTravelStories = () => {
  const fields = [
    { name: 'name', label: 'Customer Name', type: 'text', required: true, placeholder: 'e.g. Priya & Family' },
    { name: 'destination', label: 'Destination', type: 'text', required: true, placeholder: 'e.g. Thailand' },
    { name: 'image', label: 'Image URL', type: 'url', required: true, placeholder: 'https://images.unsplash.com/...', fullWidth: true },
    { name: 'rating', label: 'Rating', type: 'number', required: true, min: 1, max: 5, default: 5 },
    { name: 'story', label: 'Story', type: 'textarea', required: true, placeholder: 'Customer testimonial...', fullWidth: true },
    { name: 'date', label: 'Date', type: 'text', required: true, placeholder: 'e.g. December 2024' },
    { name: 'package', label: 'Package', type: 'text', required: true, placeholder: 'e.g. 7 Days Thailand Family Package' },
    { name: 'active', label: 'Status', type: 'boolean', checkboxLabel: 'Active', default: true },
  ];

  const columns = [
    { 
      key: 'image', 
      label: 'Image',
      render: (url) => <img src={url} alt="" className="table-thumb" />
    },
    { key: 'name', label: 'Customer' },
    { key: 'destination', label: 'Destination' },
    { 
      key: 'rating', 
      label: 'Rating',
      render: (rating) => '⭐'.repeat(rating)
    },
    { key: 'date', label: 'Date' },
    { 
      key: 'active', 
      label: 'Status',
      render: (active) => <span className={`status-badge ${active ? 'active' : 'inactive'}`}>{active ? 'Active' : 'Inactive'}</span>
    },
  ];

  return (
    <AdminCRUD
      title="Travel Stories"
      endpoint="travel-stories"
      fields={fields}
      columns={columns}
      renderPreview={true}
    />
  );
};

export default AdminTravelStories;
